import { action, makeObservable, observable } from "mobx";

class EmbedStore {
  currentArticle = null;

  constructor() {
    makeObservable(this, {
      currentArticle: observable,
      listenForCommandMessages: action.bound,
      notifyParentWindowReady: action.bound,
      onPreviousArticle: action.bound,
      onNextArticle: action.bound,
      onMaximizePlayer: action.bound,
      onMinimizePlayer: action.bound,
      onDisablePlayer: action.bound,
    });
  }

  onPreviousArticle() {
    window.parent.postMessage(
      {
        audiblogs: true,
        type: "previous_article",
      },
      "*"
    );
  }

  onNextArticle() {
    window.parent.postMessage(
      {
        audiblogs: true,
        type: "next_article",
      },
      "*"
    );
  }

  onMaximizePlayer() {
    window.parent.postMessage(
      {
        audiblogs: true,
        type: "maximize_player",
      },
      "*"
    );
  }

  onMinimizePlayer() {
    window.parent.postMessage(
      {
        audiblogs: true,
        type: "minimize_player",
      },
      "*"
    );
  }

  onDisablePlayer() {
    window.parent.postMessage(
      {
        audiblogs: true,
        type: "disable_player",
      },
      "*"
    );
  }

  listenForCommandMessages(e) {
    if (e.data && e.data.audiblogs && e.data.type) {
      switch (e.data.type) {
        case "set_article":
          this.currentArticle = e.data.payload;
          break;
        default:
          break;
      }
    }
  }

  notifyParentWindowReady() {
    window.parent.postMessage({ audiblogs: true, type: "ready" }, "*");
  }
}

const embedStore = new EmbedStore();

export default embedStore;
